export default __webpack_public_path__ + "static/media/hummus_tortilla.9fc5d216.jpg";